(function ($) {
  $(document).ready(function() {
    
    /**
     * Profile form email checkbox
     */
    // Select the elements once and store them in variables for better performance
    const signUpContainer = $('[data-name="sign_up_to_newsletter"]');
    const switchInput = signUpContainer.find('.acf-switch-input');
    const acfSwitch = signUpContainer.find('.acf-switch');
    const acfInput = signUpContainer.find('.acf-input');

    // Hide and set height to 0 using CSS instead of chaining multiple jQuery methods
    acfSwitch.css({ 'display': 'none', 'height': 0 });
    acfInput.css({ 'display': 'none', 'height': 0 });

    // Initialize the new checkbox with the opposite value of switchInput
    const newsletterValue = !switchInput.prop('checked');
    const newCheckbox = $('<input>', {
      type: 'checkbox',
      name: 'newsletter_checkbox',
      id: 'newsletter_checkbox',
      checked: newsletterValue // Set initial checked state based on the switch input
    });

    // Update the change event handler for newCheckbox
    newCheckbox.on('change', function () {
      // Directly set the checked property of switchInput to match newCheckbox
      const isChecked = $(this).prop('checked');
      switchInput.prop('checked', !isChecked);

      // Optionally, if you need to trigger any change event or specific functionality
      // when switchInput's checked state changes, do that here.
      // For example, if switchInput's change event needs to be manually triggered:
      switchInput.change(); 
    });

    // Create a div to wrap the checkbox
    const checkboxWrapper = $('<div>', {
      class: 'ps-5 pb-5 mt-n3' // Optionally, add a class for styling
    });

    // Append the new checkbox to the wrapper div
    newCheckbox.appendTo(checkboxWrapper);
    checkboxWrapper.insertAfter(signUpContainer);

    /**
     * jCarousel
     */
    var jcarousel = $(".jcarousel");


    let width = jcarousel.innerWidth();

    $('.c-item').css('width', '200px');

    jcarousel
      .on("jcarousel:reload jcarousel:create", function () {
        var carousel = $(this),
          width = carousel.innerWidth();

        if (width >= 600) {
          width = width / 4;
        } else if (width >= 350) {
          width = width / 2;
        }
        
        let itemCount = carousel.jcarousel("items").length;
        $('#issues-carousel').css('width', width * itemCount + 'px');
        carousel.jcarousel("items").css("width", Math.ceil(width) + "px");
      })
      .jcarousel({
        wrap: "circular",
        transitions: true,
        animation: {
          duration: 800,
          easing: "linear",
        },
      });

    // jcarousel.jcarouselAutoscroll({
    //   interval: 10000
    // });
    $(".jc-left").jcarouselControl({
      target: "-=1",
    });

    $(".jc-right").jcarouselControl({
      target: "+=1",
    });

    $(".jcarousel-pagination")
      .on("jcarouselpagination:active", "a", function () {
        $(this).addClass("active");
      })
      .on("jcarouselpagination:inactive", "a", function () {
        $(this).removeClass("active");
      })
      .on("click", function (e) {
        e.preventDefault();
      })
      .jcarouselPagination({
        perPage: 1,
        item: function (page) {
          return '<a href="#' + page + '">' + page + "</a>";
        },
      });






  });


  //  });
})(jQuery);
